<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        {{ me.business_name }}
      </content-page-title>
    </template>

    <Enable :pro="me" />
    <Contact :pro="me" />
    <Address :pro="me" />
  </ContentPage>
</template>

<script>

import { ContentPage, ContentPageTitle } from '@/components/pages'
import { Address, Contact, Enable } from './sections'

import { mapGetters } from 'vuex'

export default {
  components: {
    ContentPage,
    ContentPageTitle,
    Address,
    Contact,
    Enable,
  },
  
  computed: {
    ...mapGetters('auth', { me: 'me' })
  },

  created() {
    this.$store.dispatch('auth/loadMe')
  },
}
</script>